import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";

export default function ModalInit({ url, linkToo, imgLink }) {
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);

  // Usa la copia local optimizada en /assets/imgPopup/ para carga instantánea y sin bloqueos de red
  const localImg = process.env.PUBLIC_URL + "/assets/imgPopup/Consejos.webp";
  const [src, setSrc] = useState(
    imgLink && imgLink.includes("Consejos") ? localImg : imgLink
  );

  const handleError = () => {
    if (src === localImg) {
      setSrc(process.env.PUBLIC_URL + "/assets/imgPopup/Consejos.jpg");
    } else if (src !== imgLink) {
      setSrc(imgLink);
    }
  };

  return (
    <>
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: "center" }}>
            {url === "" && linkToo === "" ? (
              <img
                className="img-fluid"
                src={src}
                alt="Imagen del popup"
                style={{ width: "75%", margin: "0 auto" }}
                fetchPriority="high"
                loading="eager"
                onError={handleError}
              />
            ) : url === "" && linkToo !== "" ? (
              <Link to={linkToo}>
                <img
                  className="img-fluid"
                  src={src}
                  alt="Imagen del popup"
                  style={{ width: "100%" }}
                  fetchPriority="high"
                  loading="eager"
                  onError={handleError}
                />
              </Link>
            ) : (
              <a href={url} target="_blank" rel="noreferrer">
                <img
                  className="img-fluid"
                  src={src}
                  alt="Imagen del popup"
                  style={{ width: "100%" }}
                  fetchPriority="high"
                  loading="eager"
                  onError={handleError}
                />
              </a>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
